import { AxiosError } from 'axios';
import { CommandResult, FormApiService, ItemCommandResult, QueryApiService } from 'src/common/api-service';
import { AddEnterpriseUserBody, AddEnterpriseUserResult, PasswordBody, EmailBody, CheckPassword, SetPassword } from './types';

export class UsersApiService extends QueryApiService<any> {
  constructor() {
    super('users');
    this._apiBaseUrl = `${window.REACT_APP_OIDC_AUTHORITY}/api/v1/users`;
    this._odataBaseUrl = `${window.REACT_APP_OIDC_AUTHORITY}/odata/v1/users`;
  }

  public async hasEmailConfirmed(options: { userId?: string; userEmail?: string }): Promise<boolean> {
    try {
      return (await this.get<{ emailConfirmed: boolean }>('hasEmailConfirmed', options))?.emailConfirmed;
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<{ emailConfirmed: boolean }>>;
      if (axiosError?.response?.data == null) throw e;
      throw Error(axiosError.response.data.error);
    }
  }

  public async hasPassword(): Promise<{ hasPassword: boolean }> {
    try {
      const response = await this.get<{ hasPassword: boolean }>('hasPassword');
      return response;
    } catch (e) {
      const axiosError = e as AxiosError<{ hasPassword: boolean }>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}

export class UsersFormApiService extends FormApiService {
  constructor() {
    super('users');
    this._apiBaseUrl = `${window.REACT_APP_OIDC_AUTHORITY}/api/v1/users`;
    this._odataBaseUrl = `${window.REACT_APP_OIDC_AUTHORITY}/odata/v1/users`;
  }
  public async resendWelcomeEmail(options: { userId?: string; userEmail?: string }): Promise<CommandResult> {
    return await this.post(options, 'resendWelcomeEmail');
  }

  public async resendEnterpriseUserWelcomeEmail(options: {
    userId?: string;
    userEmail?: string;
    enterpriseName?: string;
    enterpriseAdminName?: string;
  }): Promise<CommandResult> {
    try {
      return await this.post(options, 'resendEnterpriseUserWelcomeEmail');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async addEnterpriseUser(body: AddEnterpriseUserBody): Promise<ItemCommandResult<AddEnterpriseUserResult>> {
    try {
      return await this.post(body, 'addEnterpriseUser');
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<AddEnterpriseUserResult>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async changePassword(body: PasswordBody): Promise<CommandResult> {
    try {
      return await this.put(body, 'changePassword', false);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async changeEmail(body: EmailBody): Promise<CommandResult> {
    try {
      return await this.post(body, 'changeEmail');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async checkPassword(password: CheckPassword): Promise<CommandResult> {
    try {
      return await this.post(password, 'checkPassword');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async setPassword(password: SetPassword): Promise<CommandResult> {
    try {
      return await this.post(password, 'setPassword');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
